export default __webpack_public_path__ + "static/media/baton_black.66b7ee44.jpg";